import { NotesIcon } from './icons'

/**
 * Shown while the app has nothing to draw yet.
 *
 * Signing in and the first Firestore sync can take tens of seconds on a cold
 * mobile connection, and until now that time was a black screen — which reads
 * as a crash rather than as progress. An indeterminate bar is honest here: the
 * work has no measurable percentage, but it is clearly still happening.
 */
export function Splash({ message }: { message: string }) {
  return (
    <div className="splash" role="status" aria-live="polite">
      <span className="splash-mark" aria-hidden><NotesIcon size={44} /></span>
      <h1>Indigo Notes</h1>
      <p>{message}</p>
      <div className="splash-track" aria-hidden><span className="splash-bar" /></div>
    </div>
  )
}
